<template>
  <div>
    <!-- 不要按钮！只保留容器 -->
    <div ref="captchaContainer"></div>
  </div>
</template>

<script>
import captchaId from '../../captchaId'
export default {
  data() {
    return {
      captcha: null,
      ready: false,
      resolveFn: null,
      rejectFn: null
    }
  },

  mounted() {
    this.initCaptcha()
  },

  methods: {
    initCaptcha() {
      initAlicom4(
        {
          captchaId: captchaId.captchaId,
          product: captchaId.product // ⭐关键：必须加
        },
        (captchaIns) => {
          this.captcha = captchaIns
          this.ready = true

          captchaIns
            .onSuccess(() => {
              const result = captchaIns.getValidate()

              if (this.resolveFn) {
                this.resolveFn(result)
              }
            })
            .onError((err) => {
              if (this.rejectFn) {
                this.rejectFn(err)
              }
            })
        }
      )
    },

    verify() {
      return new Promise((resolve, reject) => {
        if (!this.ready) {
          reject('captcha not ready')
          return
        }

        this.resolveFn = resolve
        this.rejectFn = reject

        // 🚨 关键：直接弹，不依赖 DOM
        this.captcha.showCaptcha()
      })
    }
  }
}
</script>
